/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatLogData } from './ChatLogData';
import {
    ChatLogDataFromJSON,
    ChatLogDataFromJSONTyped,
    ChatLogDataToJSON,
    ChatLogDataToJSONTyped,
} from './ChatLogData';
import type { ThreadSummary } from './ThreadSummary';
import {
    ThreadSummaryFromJSON,
    ThreadSummaryFromJSONTyped,
    ThreadSummaryToJSON,
    ThreadSummaryToJSONTyped,
} from './ThreadSummary';

/**
 * 
 * @export
 * @interface GetChatLogsThreadResponse
 */
export interface GetChatLogsThreadResponse {
    /**
     * 
     * @type {ThreadSummary}
     * @memberof GetChatLogsThreadResponse
     */
    thread: ThreadSummary;
    /**
     * 
     * @type {Array<ChatLogData>}
     * @memberof GetChatLogsThreadResponse
     */
    logs: Array<ChatLogData>;
}

/**
 * Check if a given object implements the GetChatLogsThreadResponse interface.
 */
export function instanceOfGetChatLogsThreadResponse(value: object): value is GetChatLogsThreadResponse {
    if (!('thread' in value) || value['thread'] === undefined) return false;
    if (!('logs' in value) || value['logs'] === undefined) return false;
    return true;
}

export function GetChatLogsThreadResponseFromJSON(json: any): GetChatLogsThreadResponse {
    return GetChatLogsThreadResponseFromJSONTyped(json, false);
}

export function GetChatLogsThreadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChatLogsThreadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'thread': ThreadSummaryFromJSON(json['thread']),
        'logs': ((json['logs'] as Array<any>).map(ChatLogDataFromJSON)),
    };
}

export function GetChatLogsThreadResponseToJSON(json: any): GetChatLogsThreadResponse {
    return GetChatLogsThreadResponseToJSONTyped(json, false);
}

export function GetChatLogsThreadResponseToJSONTyped(value?: GetChatLogsThreadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'thread': ThreadSummaryToJSON(value['thread']),
        'logs': ((value['logs'] as Array<any>).map(ChatLogDataToJSON)),
    };
}

